// extracted by mini-css-extract-plugin
export default {"title":"Section_title__BU30R"};